import { Button, buttonVariants } from "@devhop/ui";
import { Link } from "@tanstack/react-router";
import { RefreshCw } from "lucide-react";

type FeedsToolbarProps = {
  onSync: () => void;
  syncing?: boolean;
};

export function FeedsToolbar({ onSync, syncing }: FeedsToolbarProps) {
  return (
    <div className="mb-6 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
      <div>
        <h1 className="font-semibold text-2xl tracking-tight">ຈັດການຫນ້າຟີດ</h1>
        <p className="text-muted-foreground text-sm">
          ລາຍການໂພສຈາກ Page ທີ່ເຊື່ອມ — ເປີດ/ປິດຮັບຄອມເມັນສັ່ງຊື້
        </p>
      </div>
      <div className="flex flex-wrap gap-2">
        <Link
          to="/app/feeds/post-products"
          search={{ pageId: undefined, feedId: undefined }}
          className={buttonVariants({ variant: "outline" })}
        >
          ສ້າງສິນຄ້າໃນໂພສ
        </Link>
        <Button
          type="button"
          variant="outline"
          disabled={syncing}
          onClick={onSync}
        >
          <RefreshCw className={`size-4 ${syncing ? "animate-spin" : ""}`} />
          ດຶງໂພສໃໝ່
        </Button>
      </div>
    </div>
  );
}
